import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setLogout } from "features/authSlice";
import { afterLogoutApi } from "pages/login/afterLogoutService";
import { clearLoanOfficerDetail } from "services/common/loanOfficerSlice";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: setLogout,
  effect: async (_, listenerApi) => {
    listenerApi.dispatch(clearLoanOfficerDetail());
    try {
      await listenerApi.dispatch(afterLogoutApi.endpoints.postAfterLogout.initiate());
    } catch (err) {
      console.error("Failed to call after-logout endpoint", err);
    }
  },
});
